module.exports = __webpack_public_path__ + "media/images/redesign-images/sorority/cloud/sorority-cloud-02-medium-636d00f4b6872cca94cada2126f557fc.jpg";